package utils

import com.soywiz.klock.*
import com.soywiz.korge.view.*
import com.soywiz.korim.bitmap.*

fun Container.parallax(
    backGround: Bitmap,
    layer1: Bitmap,
    layer2: Bitmap,
    layer3: Bitmap
) {
    fullsScreenImage(backGround)

    val pLayer1 = parallaxLayer(layer1)
    val delta1 = -calculateParallaxDelta(64)

    val pLayer2 = parallaxLayer(layer2)
    val delta2 = -calculateParallaxDelta(32)

    val pLayer3 = parallaxLayer(layer3)
    val delta3 = -calculateParallaxDelta(16)

    addFixedUpdater(16.milliseconds) {
        pLayer1.move(delta1)
        pLayer2.move(delta2)
        pLayer3.move(delta3)
    }
}

fun Container.managedParallax(
    backGround: Bitmap,
    layer1: Bitmap,
    layer2: Bitmap,
    layer3: Bitmap,
): ParallaxLayers {
    fullsScreenImage(backGround)

    val pLayer1 = parallaxLayer(layer1)

    val pLayer2 = parallaxLayer(layer2)

    val pLayer3 = parallaxLayer(layer3)

    return ParallaxLayers(pLayer1, pLayer2, pLayer3)
}

private fun calculateParallaxDelta(seconds: Int): Double {
    return GameDimensions.V_WIDTH / (60.0 * seconds)
}

data class ParallaxLayers(
    val layer1: ParallaxLayer,
    val layer2: ParallaxLayer,
    val layer3: ParallaxLayer,
)

data class ParallaxLayer(
    val img1: Image,
    val img2: Image,
) {
    fun move(deltaX: Double) {
        img1.position(img1.x + deltaX, img1.y)
        img2.position(img2.x + deltaX, img2.y)

        if (img1.x <= -img1.scaledWidth) {
            img1.position(img2.x + img2.scaledWidth, img1.y)
        }

        if (img2.x <= -img2.scaledWidth) {
            img2.position(img1.x + img1.scaledWidth, img2.y)
        }

        if (img1.x >= img1.scaledWidth) {
            img1.position(img2.x - img2.scaledWidth, img1.y)
        }

        if (img2.x >= img2.scaledWidth) {
            img2.position(img1.x - img1.scaledWidth, img2.y)
        }
    }

}

private fun Container.parallaxLayer(bitmap: Bitmap): ParallaxLayer {
    val img1 = fullsScreenImage(bitmap)
        .position(0, 0)
        .apply { visible = true }
    val img2 = fullsScreenImage(bitmap)
        .position(img1.x + img1.scaledWidth, 0.0)
        .apply { visible = true }

    return ParallaxLayer(img1, img2)
}

private fun Container.fullsScreenImage(bitmap: Bitmap): Image {
    val scaleX = 1.0 / (bitmap.width.toDouble() / GameDimensions.V_WIDTH.toDouble())
    val scaleY = 1.0 / (bitmap.height.toDouble() / GameDimensions.V_HEIGHT.toDouble())
    return image(bitmap.slice()) {
        this.scaleX = scaleX
        this.scaleY = scaleY
    }
}
